import Format from "../components/format/Format";

export default function Html() {

    return (
        <Format inputLabel='HTML' 
            buttons={[
                {
                    api: '/api/html/pretty-print',
                    buttonLabel: 'Format',
                    outputLabel: 'HTML',
                },
            ]}
        />
    );
}